import { Dispatch, SetStateAction } from 'react';
import { TeamOutlined, PlusOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import PageHeader from 'components/new-ui/base/page-header/PageHeader';

type Props = {
    canUpdate: boolean;
    setShowCreateTeamDrawer: Dispatch<SetStateAction<boolean>>;
};

const Header = ({ canUpdate, setShowCreateTeamDrawer }: Props) => {
    return (
        <PageHeader
            title="Teams"
            icon={<TeamOutlined />}
            sidebar={
                canUpdate && (
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowCreateTeamDrawer(true)}>
                        New Team
                    </Button>
                )
            }
        />
    );
};

export default Header;
